import React, { Component } from "react";
import uuid from "uuid";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import { extractListItemsFromResponse } from "../../utils/actions";
import { ValidationProvider } from "../../validation/validation-provider";

import { NameChangeRequest } from "./NameChangeRequest";
import { MailingAddressChangeRequest } from "./MailingAddressChangeRequest";
import { ReplacePropertyLocationRequest } from "./ReplacePropertyLocationRequest";
import { AddNewPropertyLocationRequest } from "./AddNewPropertyLocationRequest";
import { DeletePropertyLocationRequest } from "./DeletePropertyLocationRequest";
import { ReplaceVehicleRequest } from "./ReplaceVehicleRequest";
import { AddNewVehicleRequest } from "./AddNewVehicleRequest";
import { DeleteVehicleRequest } from "./DeleteVehicleRequest";
import { WcWaiverOfSubrogationRequest } from "./WcWaiverOfSubrogationRequest";
import { AdditionalInsuredRequest } from "./AdditionalInsuredRequest";
import { AddHnoaToGlBopRequest } from "./AddHnoaToGlBopRequest";
import { AddDeleteLossPayeeRequest } from "./AddDeleteLossPayeeRequest";
import { AddDeleteMortgageeRequest } from "./AddDeleteMortgageeRequest";
import { AddDeleteEmployeeRequest } from "./AddDeleteEmployeeRequest";
import { AddDeleteDriverRequest } from "./AddDeleteDriverRequest";
import { AddDeleteWaiverOfSubrogationRequest } from "./AddDeleteWaiverOfSubrogationRequest";
import { OtherMiscRequest } from "./OtherMiscRequest";
import { PolicyLimitChangeRequest } from "./PolicyLimitChangeRequest";
import { WcPayrollChangeRequest } from "./WcPayrollChangeRequest";
import { FEINNumberChangeRequest } from "./FEINNumberChangeRequest";
import { ContactInfoChangeRequest } from "./ContactInfoChangeRequest";

export class QuoteChangeRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTypeOfChange: null,
      listItemData: null,
      data: {
        file: null,
      },
    };

    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.loadListItemData();
  }

  render() {
    var listItemData = this.state.listItemData;

    if (!listItemData) {
      return null;
    }

    return (
      <div>
        {this.state.listItemData && (
          <div className="quote-change">
            <div className="quote-change-request">
              <div>
                <span>Select a Type of Change</span>
                <select
                  className="quote-change-dropdown quote-type-of-change-dropdown"
                  onChange={(e) => this.handleSelectTypeOfChange(e)}
                >
                  {this.state.listItemData.typesOfChange.map((opt) => (
                    <option
                      value={opt.Value}
                      selected={opt.Value === this.state.selectedTypeOfChange}
                      key={uuid()}
                    >
                      {opt.Name}
                    </option>
                  ))}
                </select>
              </div>
              {this.renderRequestForm()}
            </div>
            <div className="quote-change-button-section">
              <button
                className="btn btn-default quote-change-cancel-button"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.prevStep();
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary quote-change-submit-button"
                onClick={(e) => this.handleSubmitRequest(e)}
              >
                Submit Request
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderRequestForm() {
    var props = this.createChildProps();

    switch (this.state.selectedTypeOfChange) {
      case "NameChange":
        return <NameChangeRequest {...props} />;
      case "MailingAddressChange":
        return <MailingAddressChangeRequest {...props} />;
      case "ReplacePropertyLocation":
        return <ReplacePropertyLocationRequest {...props} />;
      case "AddNewPropertyLocation":
        return <AddNewPropertyLocationRequest {...props} />;
      case "DeletePropertyLocation":
        return <DeletePropertyLocationRequest {...props} />;
      case "ReplaceVehicle":
        return <ReplaceVehicleRequest {...props} />;
      case "AddNewVehicle":
        return <AddNewVehicleRequest {...props} />;
      case "DeleteVehicle":
        return <DeleteVehicleRequest {...props} />;
      case "OtherMisc":
        return <OtherMiscRequest {...props} />;
      case "PolicyLimitChange":
        return <PolicyLimitChangeRequest {...props} />;
      case "WcPayrollChange":
        return <WcPayrollChangeRequest {...props} />;
      case "WcWaiverOfSubrogation":
        return <WcWaiverOfSubrogationRequest {...props} />;
      case "AdditionalInsured":
        return <AdditionalInsuredRequest {...props} />;
      case "AddHnoaToGlBop":
        return <AddHnoaToGlBopRequest {...props} />;
      case "AddDeleteLossPayee":
        return <AddDeleteLossPayeeRequest {...props} />;
      case "AddDeleteMortgagee":
        return <AddDeleteMortgageeRequest {...props} />;
      case "AddDeleteEmployee":
        return <AddDeleteEmployeeRequest {...props} />;
      case "AddDeleteWaiverOfSubrogation":
        return <AddDeleteWaiverOfSubrogationRequest {...props} />;
      case "AddDeleteDriver":
        return <AddDeleteDriverRequest {...props} />;
      case "FEINNumberChange":
        return <FEINNumberChangeRequest {...props} />;
      case "ContactInfoChange":
        return <ContactInfoChangeRequest {...props} />;
      default:
        return null;
    }
  }

  createChildProps() {
    var listItemData = this.state.listItemData;

    return {
      states: listItemData.states,
      maximumRadiusesOfOperations: listItemData.maximumRadiusesOfOperations,
      constructionTypes: listItemData.constructionTypes,
      data: this.state.data,
      updateRequest: this.updateRequest,
      updateAddress: this.updateAddress,
      formRef: this.formRef,
    };
  }

  updateRequest = (requestPropertyName, requestPropertyValue) => {
    this.setState((prevState, props) => {
      return {
        data: Object.assign(prevState.data, {
          [requestPropertyName]: requestPropertyValue,
        }),
      };
    });
  };

  updateAddress = (
    zipCodePropertyName,
    zipCodePropertyValue,
    statePropertyName,
    cityProperyName
  ) => {
    //request zipcodelookup
    this.setState((prevState, props) => {
      return {
        data: Object.assign(prevState.data, {
          [zipCodePropertyName]: zipCodePropertyValue,
          //[statePropertyName]: zipcodeLookup.State,
          //[cityProperyName]: zipcodeLookup.City,
        }),
      };
    });
  };

  loadListItemData() {
    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}listitems?keys=typeofchange&keys=constructiontypes&keys=maximumradiusesofoperations&keys=state`
      )
      .then((data) => {
        var typesOfChange = extractListItemsFromResponse(data, "typeofchange");

        this.setState({
          listItemData: {
            typesOfChange: typesOfChange,
            constructionTypes: extractListItemsFromResponse(
              data,
              "constructiontypes"
            ),
            maximumRadiusesOfOperations: extractListItemsFromResponse(
              data,
              "maximumradiusesofoperations"
            ),
            states: extractListItemsFromResponse(data, "state"),
          },
          selectedTypeOfChange: typesOfChange[0].Value,
        });
      })
      .catch((e) => {});
  }

  sendRequest() {
    var request = Object.assign(this.state.data, {
      quoteIds: this.props.quoteIds,
    });

    axios
      .post(
        `${
          BACKEND_CONFIG.apiUrl
        }quote/changerequests/${this.state.selectedTypeOfChange.toLowerCase()}requests`,
        request
      )
      .then((result) => this.props.history.push("/home"))
      .catch((error) => {
        if (!error.response.data || !error.response.data.ValidationErrors) {
          alert("Something went wrong");
          return;
        }
        this.props.onServerValidationErrors(
          error.response.data.ValidationErrors
        );
      });
  }

  handleSelectTypeOfChange(e) {
    var value = e.target.value;

    this.setState((prevState, props) => {
      return {
        data: Object.assign(prevState.data, { file: null }),
        selectedTypeOfChange: value,
      };
    });
  }

  handleSubmitRequest(e) {
    e.preventDefault();
    let isValid = ValidationProvider.isValid(this.formRef);

    if (isValid) {
      this.sendRequest();
    }
  }
}
